import {BaseService} from '../baseService.js';

/* 
 * Handles Trailser
 */
export class TrailerService extends BaseService {

	constructor() {	
		super();
	}
	
	async getTrailers(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/trailers' + params);
		return data;
	}	

	async getTrailer(trailerId) {
		var data = await this.makeGETRequest('/api/resource/trailers/' + trailerId);		
		return data;		
	}	
	
	exportTrailers(paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/trailers/export' + params);		
	};
	
	async saveTrailer(trailer, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/trailers/' + trailer.trailerId, trailer);
		} else {
			saved = await this.makePOSTRequest('/api/resource/trailers', trailer);
		}
		return saved;
	}	
	
	async getTrailerMultiRefs(trailerId) {		
		var result = await this.makeGETRequest('/api/resource/trailers/' + trailerId + "/references");		
		return result;
	}	
	
	async getTrailerMultiRef(trailerId, referenceId) {		
		var result = await this.makeGETRequest('/api/resource/trailers/' + trailerId + "/references/" + referenceId);		
		return result;
	}	
	
	async saveTrailerMultiRef(trailerMultiRef, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/trailers/' + trailerMultiRef.trailerId +  '/references/' + trailerMultiRef.multiReferenceId, trailerMultiRef);
		} else {
			saved = await this.makePOSTRequest('/api/resource/trailers/' + trailerMultiRef.trailerId +  '/references', trailerMultiRef);
		}
		return saved;
	}
		
	async deleteTrailerMultiRef(trailerId, referenceId) {		
		var result = await this.makeDELETERequest('/api/resource/trailers/' + trailerId + "/references/" + referenceId);		
		return result;
	}
	
	async activateTrailer(trailerId) {	
		var result = await this.makePUTRequest('/api/resource/trailers/' + trailerId + '/activate');
		return result;
	}	

	async inactivateTrailer(trailerId) {	
		var result = await this.makePUTRequest('/api/resource/trailers/' + trailerId + '/inactivate');
		return result;
	}	
	
	async activateTrailers(trailerIds) {	
		var result = await this.makePUTRequest('/api/resource/trailers/activate', trailerIds);
		return result;
	}	

	async inactivateTrailers(trailerIds) {	
		var result = await this.makePUTRequest('/api/resource/trailers/inactivate', trailerIds);
		return result;
	}	
	
};

